import { Component, input } from '@angular/core';
import { staticImages } from '@shared/helper/configs';

@Component({
  selector: 'app-sheyda-badge',
  templateUrl: './sheyda-badge.component.html',
  styleUrl: './sheyda-badge.component.scss',
})
export class SheydaBadgeComponent {
  Text = input<string>();
  IsExclusive = input(false);
  Size = input<'small' | 'big'>('small');
  staticImages = staticImages;
}
